<div *tuiLet="footer$ | async as footer" class="footer-container">
  <div class="footer-container-top">
    <div class="footer-container-top-left">
      <a class="footer-container-top-left-logo" routerLink="/">
        <ng-container *ngIf="footerLogo$ | async as footerLogo">
          <img [src]="footerLogo | imageVariant: {width: 256, height: 256}" />
        </ng-container>
      </a>
      <ng-container *ngFor="let link of links$ | async">
        @if (link.routerLink) {
        <a
          class="footer-container-top-left-navigation-links"
          [routerLink]="link.routerLink"
          routerLinkActive="active-link"
          *ngIf="!link.hidden"
        >
          {{ link.label | translate }}
        </a>
        } @else {
        <a
          class="footer-container-top-left-navigation-links"
          [href]="link.href"
          *ngIf="!link.hidden"
        >
          {{ link.label | translate }}
        </a>
        }
      </ng-container>
    </div>
    <div class="footer-container-top-right">
      <div
        *ngIf="
          footer?.facebook_url ||
          footer?.twitter_url ||
          footer?.youtube_url ||
          footer?.instagram_url
        "
        class="footer-container-top-right-social"
      >
        <div>Social media</div>
        <div class="footer-container-top-right-social-icons">
          <a *ngIf="footer?.facebook_url" [href]="footer?.facebook_url" target="_blank"
            ><tui-svg src="facebook"></tui-svg
          ></a>
          <a *ngIf="footer?.instagram_url" [href]="footer?.instagram_url" target="_blank"
            ><tui-svg src="instagram"></tui-svg
          ></a>
          <a *ngIf="footer?.youtube_url" [href]="footer?.youtube_url" target="_blank"
            ><tui-svg src="youtube"></tui-svg
          ></a>
          <a *ngIf="footer?.twitter_url" [href]="footer?.twitter_url" target="_blank"
            ><tui-svg src="x"></tui-svg
          ></a>
        </div>
      </div>
      <div
        *ngIf="footer?.apple_app_store_url || footer?.google_play_url"
        class="footer-container-top-right-apps"
      >
        <div>{{ 'footer.mobileApp' | translate }}</div>
        <div class="footer-container-top-right-apps-icons">
          <a
            *ngIf="footer?.apple_app_store_url"
            [href]="footer?.apple_app_store_url"
            target="_blank"
            ><img src="assets/img/app-store-pl.svg" alt="App store"
          /></a>
          <a
            *ngIf="footer?.google_play_url"
            [href]="footer?.google_play_url"
            target="_blank"
            ><img src="assets/img/google-play-pl.svg" alt="Google Play"
          /></a>
        </div>
      </div>
      <div
        *ngIf="contactEmail$ | async as contactEmail"
        class="footer-container-top-right-help"
      >
        <div>{{ 'footer.help' | translate }}</div>
        <div class="footer-container-top-right-help-email">
          {{ 'footer.contact' | translate }}
          <a [href]="'mailto:' + contactEmail" class="notranslate">
            {{ contactEmail }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-container-divider">
    <hr />
  </div>
  <div class="footer-container-bottom">
    <div class="footer-container-bottom-copyrights">
      <div class="footer-container-bottom-copyrights-site-name">
        © {{ 'meta.url' | translate }}
      </div>
    </div>
    <div class="footer-container-bottom-privacy">
      <a
        *ngIf="assetMap.docs?.dataProtectionPolicy; else dataProtection"
        [href]="assetMap.docs?.dataProtectionPolicy"
        target="_blank"
        class="footer-container-bottom-privacy-policy"
      >
        {{ 'cookies.dataProtectionPolicy' | translate }}
      </a>
      <ng-template #dataProtection>
        <a
          [routerLink]="['/', RouteNames.dataProtectionPolicy]"
          class="footer-container-bottom-privacy-policy"
        >
          {{ 'cookies.dataProtectionPolicy' | translate }}
        </a>
      </ng-template>

      <a
        *ngIf="assetMap.docs?.terms; else terms"
        [href]="assetMap.docs?.terms"
        target="_blank"
        class="footer-container-bottom-privacy-statute"
      >
        {{ 'footer.terms' | translate }}
      </a>
      <ng-template #terms>
        <a
          [routerLink]="['/', RouteNames.terms]"
          class="footer-container-bottom-privacy-statute"
        >
          {{ 'footer.terms' | translate }}
        </a>
      </ng-template>
      <a
        *ngIf="assetMap.docs?.cookiePolicy"
        [href]="assetMap.docs?.cookiePolicy"
        target="_blank"
        class="footer-container-bottom-privacy-statute"
      >
        {{ 'footer.cookiePolicy' | translate }}
      </a>
      <a *ngIf="isGdprClient" (click)="cookieSettingsClicked.emit()">{{
        'footer.cookieSettings' | translate
      }}</a>
      <ng-container *ngIf="languageService.currentLanguage$ | async as lang">
        <a
          *ngIf="assetMap.docs?.informationObligation?.[lang]"
          [href]="assetMap.docs?.informationObligation?.[lang]"
          target="_blank"
          class="footer-container-bottom-privacy-statute"
        >
          {{ 'footer.informationObligation' | translate }}
        </a>
      </ng-container>
      <a
        *ngIf="
          (clientDocuments$ | async)?.information_obligation as informationObligation
        "
        [href]="informationObligation"
        target="_blank"
        class="footer-container-bottom-privacy-statute"
      >
        {{ 'footer.informationObligation' | translate }}
      </a>
    </div>
    <div class="footer-container-bottom-powered-by">
      <div>Powered by</div>
      <a href="https://www.tisagroup.ch" target="_blank">
        <img src="assets/img/logo-tisa.svg" />
      </a>
    </div>
  </div>
</div>
